import 'tslib';
import 'long';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import { Conversation } from '../../core/model/Conversation.js';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import 'json-long';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

/** 陌生人会话 */
class StrangerConversation extends Conversation {
    /** 陌生人会话未读数 */
    get unreadCount() {
        return this.internalUnreadCount;
    }
    /** @internal */
    set unreadCount(val) {
        this.internalUnreadCount = val;
    }
    /**
     * 会话推拉模式 (陌生人)
     * 陌生人 mode 解释:
     * - 0 熟人会话
     * - 0x1（001b）表示在 ConversationId 后面的是陌生人
     * - 0x2（010b）表示在 ConversationId 前面的是陌生人
     */
    get mode() {
        const toParticipant = this.toParticipantUserId;
        const idSplit = this.id.split(':');
        // 自己一定是拉模式(对方是陌生人), 所以检查哪一位是对方的uid就行
        if (idSplit[2] === toParticipant) { // minUid是对方, mode == 01
            return 0b01;
        }
        if (idSplit[3] === toParticipant) { // maxUid是对方 mode == 10
            return 0b10;
        }
        // 兜底
        // TODO: 双方都可能是陌生人
        return 3;
    }
    /** @internal */
    get ext() {
        return this.coreInfo.ext;
    }
    /** @internal */
    set ext(val) {
        this.coreInfo.ext = val;
    }
}

export { StrangerConversation };
//# sourceMappingURL=StrangerConversation.js.map
